module.exports = __webpack_public_path__ + "static/media/no.370a214a.mp3";